define('SageDotCom/DataLayer/Events/Forms/fieldCompletionError',['jquery', 'SageDotCom/DataLayer/Events/eventBase'], function ($, EventBase) {

    function FormCompletionErrorEvent() {
        EventBase.call(this); // inherit eventBase
        this.name = 'field_completion_error'; // overwrite name
    }

    FormCompletionErrorEvent.prototype = Object.create(EventBase.prototype);

    FormCompletionErrorEvent.prototype.GenerateEventMetadata = function GenerateEventMetadata(scope) {
        var eventData = {
            "event_name": this.getName(), //event name
            "event_non-int": "0", //non interaction point
            "event_category": "contact", //top line category
            "event_action": "form field complete error" //specific action
        };

        if (scope) {
            var lbl = $(scope).data("sc-field-name") || $(scope).attr("name") ||  $(scope).prev('label').text();
            var location = this.getLocation(scope);
            var level5 = $(scope).closest('form').find('[data-sc-field-name="Level5"]');

            eventData = $.extend(eventData, {
                'event_label': this.cleanseString(lbl),
                'event_name_level_1': this.getId(scope),
                'event_name_level_2': $(scope).closest('form').attr('id'),
                'event_name_level_3': "(not set)",
                'event_name_level_4': location,
                'event_name_level_5': level5.length > 0 ? level5[0].defaultValue : "(not set)"
            });
        }

        return eventData;
    }

    return new FormCompletionErrorEvent();
});
